import React from "react";
import {connect} from 'react-redux'
import {Link} from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

//Icons
import StoreMallDirectory from "@material-ui/icons/StoreMallDirectory";
import AddIcon from "@material-ui/icons/Add";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

// core components
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";


import Table from "components/Table/Table.jsx";
import LinearProgress from '@material-ui/core/LinearProgress';
import Checkbox from "components/Checkbox/Checkbox";

//Table actions
import Actions from 'views/Tables/Actions'

//Approve popUp
import ConfirmAlert from 'components/Alert/Confirm'
import ProgressAlert from 'components/Alert/Progress'
import SuccessAlert from 'components/Alert/Success'

//Styles
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx";


// Actions
import {
  companyFilter,
  companiesFetch,
  companyRemove
} from 'actions/companies'

class List extends React.Component {
  selected=[]
  state = {
    selected: []
  }
  componentDidMount(){
    this.props.filter({size: 10})
    this.props.fetch()
  }
  //on choose record
  select(id) {
    let select = []
    if (Array.isArray(id)) 
      select = (this.state.selected.length > 0)
        ? []
        : id
    else if (this.state.selected.indexOf(id) > -1) 
      select = this.state.selected.filter((e) => e !== id)
    else 
      select = this
        .state
        .selected
        .concat(id)
    this.setState({
      ...this.state,
      selected: select
    })
  }
  confirmDelete() {
      if(this.selected.length===0){
        this.props.fetch();
        this.setState({
          ...this.state,
          selected:[],
          alert: <SuccessAlert
            title={`Done!`}
            onConfirm={()=>{this.setState({...this.state,alert:false});}}
          />
        });
        return false;
      }
      this.setState({
        ...this.state,
        alert: <ProgressAlert
        value={100-((this.selected.length*100)/this.state.selected.length)}
        title={`Delete Companies (${this.state.selected.length-this.selected.length+'/'+this.state.selected.length})`}
        />
      });
      this.props.remove(this.selected[0])
        .then((e)=>{
          this.selected=this.selected.slice(1);
          this.confirmDelete();
        })
  }
  //on choose click delete 
  delete() {
    this.setState({
      ...this.state,
      alert: <ConfirmAlert
        text={`to delete ${this.state.selected.length} companies \n( ${
          this.state.selected.map(id=>this.props.companies.list.find(e=>e.companyId===id).name).join(', ')
        } )`}
        onCancel={()=>this.setState({...this.state,alert:false})}
        onConfirm={()=>{
          this.selected=this.state.selected.slice(0);
          this.confirmDelete();
      }}
      />
    });
  }
  //Filter change for pagination or limitation
  filter(filter){
    this.setState({...this.state,selected:[]})
    this.props.filter({
      ...this.props.companies.pageable,
      ...filter,
      page: filter.size 
        ? 0 
        : filter.page !== undefined ? filter.page : this.props.companies.pageable.page
    })
    this.props.fetch()
  }
  render() {
    const {match, companies, permissions} = this.props;
    const selected = this.state.selected
    return (
      <Card>
        {this.state.alert}
        {
        (!companies.isFetching)?
        //Top actions (pgination/limit/add/remove/edit)
        <Actions
          onPagination={(page)=>this.filter({page:page-1})}
          limit={companies.pageable.size}
          limitOptions={[10,100,200]}
          onLimitation={(page)=>this.filter({size:page})}
          pagination={companies.pageable.totalPages>1?{
            pages:companies.pageable.totalPages,
            current:companies.pageable.page+1,
          }:false}
          title={(selected.length)
            ? this.state.selected.length + ' Selected'
            : ''}
          dark={selected.length>0}
          icon={<StoreMallDirectory/>}
          actions={{
          add: (selected.length===0)
            ? <Link to={`${match.path}/add`}>
                <IconButton>
                  <AddIcon/>
                </IconButton>
              </Link>
            : '',
            delete: (selected.length>0) && permissions.includes('COMPANIES_DELETE')
              ? <IconButton onClick={this.delete.bind(this)}><DeleteIcon/></IconButton>
              : '',
            edit: (selected.length===1)
              ? <Link to={`${match.path}/${this.state.selected[0]}`}>
                  <IconButton>
                      <EditIcon/>
                  </IconButton>
                </Link>
              : ''
        }}/>:''}

        <CardBody>
          {/* If is fetching not display table*/}
          {(companies.isFetching)
            ? <LinearProgress color="primary"/>
            : (
              //Main table
              <Table
                tableHeaderColor="primary"
                sort={companies.pageable.sort}
                onSort={(e)=>this.filter({sort:{[e]:companies.pageable.sort[e]==='desc'?'asc':'desc'}}) }
                tableHead={{ 
                    checkbox:<Checkbox props = {{ 
                      onClick:()=>this.select(companies.list.map(e=>e.companyId)),
                      checked:this.state.selected.length===companies.list.length}
                    }/>,
                    companyId:"#", 
                    name:"Name", 
                    email:"Email", 
                    address:"Address",
                    description:"Description" 
                  }}
                tableData={companies.list.map((e,i) => [ 
                    <Checkbox props = {{ onClick:()=>this.select(e.companyId), checked:this.state.selected.indexOf(e.companyId)>-1 }}/>,
                    e.companyId, 
                    e.name, 
                    e.email, 
                    e.address, 
                    e.description 
                  ] )}/>
            )}
        </CardBody>
       { 
         companies.list.length>20
        ?<Actions
            onPagination={(page)=>this.filter({page:page-1})}
            pagination={companies.pageable.totalPages>1?{
              pages:companies.pageable.totalPages,
              current:companies.pageable.page+1,
            }:false}
        />:''}
      </Card>
    );
  }
}
const mapStateToProps = (state) => ({
  companies: state.companies,
  permissions: state.auth.permissions
})
const mapDispatchToProps = (dispatch) => ({
  filter: (filter) => dispatch(companyFilter(filter)),
  fetch: () => dispatch(companiesFetch()),
  remove: (id) => dispatch(companyRemove(id)),
})
export default withStyles(buttonsStyle)(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/Companies/List.jsx